var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseLoadingToolbar'),_c('nav',{attrs:{"app":""}},[_c('v-navigation-drawer',{ref:"drawerNav",staticClass:"elevation-4",attrs:{"app":"","clipped":"","mini-variant":_vm.miniVariant},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},_vm._l((6),function(i){return _c('v-skeleton-loader',_vm._b({key:i,attrs:{"type":"chip"}},'v-skeleton-loader',{
          class: 'skeleton'
        },false))}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }